import { MutableRefObject } from 'react';
import { SubmitResult } from '@shopify/react-form';

import { FormSubmitStatuses } from '@web/forms/types';

export const decorateSubmit = (
  submit: () => void,
  submitPromise: MutableRefObject<Promise<SubmitResult>>
) => {
  return async () => {
    // Resetting current promise makes sure we can submit form again.
    // Without reset submit() returns previously resolved promise.
    submitPromise.current = null;
    await submit();
    const result = await submitPromise.current;

    if (!result || result.status === FormSubmitStatuses.fail) {
      throw result;
    }
  };
};
